function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-49 141 512 512",
    style: {
      enableBackground: "new -49 141 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8f59c9"
    },
    d: "M267 574.1V608c0 24.899-20.099 45-45 45h-30c-24.901 0-45-20.101-45-45v-33.9c0-8.401 6.599-16 15-16h90c8.401 0 15 7.599 15 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8951c4"
    },
    d: "M267 574.1V608c0 24.899-20.099 45-45 45h-15v-94.9h45c8.401 0 15 7.599 15 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M207 262c-10.8 0-21.599 1.199-32.401 3.9C126.6 277 87.901 315.099 76.2 362.8c-11.7 47.999 1.8 96.599 36.299 130.499C124.8 505.6 132 523.899 132 543.7v3.3c0 24.899 20.099 46 45 46h60c24.901 0 45-21.101 45-46v-3.3c0-19.501 7.5-38.401 20.7-51.301C327.901 466.899 342 433 342 397c0-75.601-61.199-135-135-135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9259ce"
    },
    d: "M342 397c0 36-14.099 69.899-39.3 95.4-13.2 12.9-20.7 31.8-20.7 51.3v3.3c0 24.899-20.099 46-45 46h-30V262c73.801 0 135 59.399 135 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "m69.114 280.325-42.422-42.422c-5.859-5.859-5.859-15.352 0-21.211s15.352-5.859 21.211 0l42.422 42.422c5.859 5.859 5.859 15.352 0 21.211-5.859 5.86-15.351 5.86-21.211 0zM27 412h-61c-8.291 0-15-6.709-15-15s6.709-15 15-15h61c8.291 0 15 6.709 15 15s-6.709 15-15 15zm421 0h-61c-8.291 0-15-6.709-15-15s6.709-15 15-15h61c8.291 0 15 6.709 15 15s-6.709 15-15 15zM323.675 280.325c-5.859-5.859-5.859-15.352 0-21.211l42.422-42.422c5.859-5.859 15.352-5.859 21.211 0s5.859 15.352 0 21.211l-42.422 42.422c-5.86 5.86-15.352 5.86-21.211 0zM222 156v61c0 8.399-6.599 15-15 15s-15-6.601-15-15v-61c0-8.401 6.599-15 15-15s15 6.599 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bd88ec"
    },
    d: "M222 156v61c0 8.399-6.599 15-15 15v-91c8.401 0 15 6.599 15 15z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbIcon);
export default __webpack_public_path__ + "static/media/lightBulbIcon.4dde981635550ff1016cd824d29e542c.svg";
export { ForwardRef as ReactComponent };